import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router";
import { Chart } from "./Chart";
import { Back } from "@assets/Icons";

export const LoadingChart = ({ onNextStep, onTrackEvent }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const updateProgress = () => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          const randomIncrease = Math.floor(Math.random() * 11) + 5;
          const nextProgress = prevProgress + randomIncrease;

          if (nextProgress >= 100) {
            clearTimeout(intervalId);
            onNextStep?.();
            onTrackEvent?.();
            return 100;
          }
          return nextProgress;
        } else {
          clearTimeout(intervalId);
          return 100;
        }
      });
    };

    const randomDelay = Math.floor(Math.random() * 801) + 200;
    const intervalId = setTimeout(updateProgress, randomDelay);

    return () => clearTimeout(intervalId);
  }, [progress, onNextStep]);

  return (
    <div className={styles.container}>
      <h2>
        EasyFit is not just about working out, it's about{" "}
        <span>feeling good</span> on the inside and out
      </h2>
      <div className={styles.loaderContainer}>
        <div
          style={{ width: `${progress}%` }}
          className={styles.loaderFill}
        ></div>
        <p>LOADING...{progress}%</p>
      </div>
      <div className={styles.chart}>
        <Chart />
        <div className={styles.radiance}></div>
        <div className={styles.chartLabel}>
          <Back />
          Stress level
        </div>
      </div>
    </div>
  );
};
